<template>
  <div>
    <topsearch title="Import Raporu" />
    <div class="flex">
      <div class="w-72 border-r h-full">
        <SidebarVue />
      </div>
      <div class="w-full">
        <div class="overflow-scroll min-h-screen md:p-4">
          <table
            class="uk-table uk-table-hover uk-table-middle uk-table-divider"
          >
            <tr>
              <td>Excel ID</td>
              <td>Double Sayısı</td>
              <td>Eklenen Kayıt Sayısı</td>
              <td>İşlem Zamanı</td>
            </tr>
            <tr :key="item.excel_id" v-for="item in data">
              <td>{{ item.excel_id }}</td>
              <td>{{ item.double }}</td>
              <td>
                <a :href="'/list/leads/?excel_id=' + item.excel_id">{{
                  item.total
                }}</a>
              </td>
              <td>{{ item.created_at }}</td>
              <td>
                <span @click="excelDownload(item.double_ids)" class="global-button cursor-pointer">Double Listesi İndir</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SidebarVue from "../components/Ui/Admin/Sidebar.vue";
import EventBus from "../components/Ui/EventBus";
import http from "../services/http";
export default {
  components: { SidebarVue },
  name: "reportUtm",
  data() {
    return { data: [], statuses: [], utmKey: "utm_source" };
  },
  created() {
    this.getData();
  },
  methods: {
    excelDownload(ids) {
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "info",
        title: "Lütfen bekleyin",
        duration: 2000,
        body: "Dosya hazırlanıyor lütfen bekleyin",
      });

      http
        .exportDoubleExcel("leads", {
          double_ids: ids,
        })
        .then((response) => {
          if (response.data.success && response.data.excelFiles.length > 0) {
            // Dosya isimlerini birleştirerek tek bir string haline getir
            let fileList = response.data.excelFiles.join("\n");
            EventBus.$emit("bottomMessage", {
              open: true,
              type: "info",
              title: "Dosyalar hazır",
              body: fileList,
            });
          } else {
            alert("Dosya oluşturulamadı veya dosya yok.");
          }
        })
        .catch((error) => {
          console.error("İndirme hatası: ", error);
        });
    },
    getData() {
      http.getImportReports().then((response) => {
        this.data = response.data;
      });
    },
  },
};
</script>

<style></style>
